export function SuspendedBanner() {
  return (
    <div className="rounded-brand border border-red-200 bg-red-50 p-4 text-sm text-red-700">
      <p className="font-semibold">Aapka business suspend hai.</p>
      <p className="mt-1">
        Public site abhi offline hai aur naye changes nahi ho sakte. Please contact support to resolve this.
      </p>
    </div>
  );
}
